// Single entry point for the rest of the app:
//
//     import { transport } from "@/transport";
//     const info = await transport.invoke<ServerInfo>("GetServerInfo");
//
// Which implementation you get is decided once, here, by whether a WebView2 bridge exists.

import { HttpTransport } from "./httpTransport";
import { getWebViewBridge, RevitTransport } from "./revitTransport";
import type { Transport } from "./types";

export * from "./types";

function create(): Transport {
  const bridge = getWebViewBridge();
  if (bridge) return new RevitTransport(bridge);

  // Browser build. In development the API is a separate origin (the local Apibim.Api), so the
  // address is baked in. In production the API serves this bundle itself, and web/.env.production
  // sets the variable to the empty string — which is a value, not an absent one, so `??` keeps it
  // and every request goes out as a relative path against whatever host we are being served from.
  return new HttpTransport(import.meta.env.VITE_API_BASE_URL ?? "http://localhost:5080");
}

export const transport: Transport = create();
